(function(){
  function init(root){
    if (!root || root.__ds) return; root.__ds = true;
    var variants = JSON.parse(root.querySelector('[data-ds-variants]').textContent);
    var sizeIdx = parseInt(root.dataset.sizeIdx, 10);
    var low = parseInt(root.dataset.low || '2', 10);
    var title = root.dataset.title;
    var image = root.dataset.image || '';
    var inQv = !!root.closest('.ds-qv');
    var opts = [].slice.call(root.querySelectorAll('[data-ds-opt]'));
    var addBtn = root.querySelector('[data-ds-add]'), buyBtn = root.querySelector('[data-ds-buy]');
    var stock = root.querySelector('[data-ds-stock]'), priceEl = root.querySelector('[data-ds-price]'), cmpEl = root.querySelector('[data-ds-cmp]');
    var selEl = root.querySelector('[data-ds-sel]');
    var bar = root.querySelector('[data-ds-bar]'), barAdd = root.querySelector('[data-ds-bar-add]'), barMeta = root.querySelector('[data-ds-bar-meta]');
    var hasOptions = opts.length > 0;
    var chosen = opts.map(function(f){ var p = f.querySelector('[aria-pressed="true"]'); return p ? p.dataset.value : null; });
    if (sizeIdx > -1) {
      chosen[sizeIdx] = null;
      try {
        var q = new URL(location.href).searchParams.get('size');
        if (q && variants.some(function(v){ return v.options[sizeIdx] === q && v.available; })) { chosen[sizeIdx] = q; }
      } catch(e){}
    }
    function match(){
      if (!hasOptions) return variants[0];
      if (chosen.some(function(c){ return c === null; })) return null;
      return variants.find(function(v){ return v.options.every(function(o,i){ return o === chosen[i]; }); }) || null;
    }
    function render(){
      opts.forEach(function(f, i){
        f.querySelectorAll('.ds-size').forEach(function(b){
          var val = b.dataset.value;
          b.setAttribute('aria-pressed', chosen[i] === val ? 'true' : 'false');
          var possible = variants.some(function(v){
            return v.options[i] === val && v.available && v.options.every(function(o,j){ return j === i || chosen[j] === null || j === sizeIdx || o === chosen[j]; });
          });
          b.classList.toggle('is-soldout', !possible);
          b.title = possible ? '' : DS.t('sold_out', 'Sold out');
        });
      });
      var v = match();
      if (selEl) selEl.textContent = (sizeIdx > -1 && chosen[sizeIdx]) ? '· ' + chosen[sizeIdx] : '';
      if (v) {
        priceEl.textContent = DS.money(v.price);
        if (cmpEl) { cmpEl.hidden = !(v.cmp > v.price); cmpEl.textContent = DS.money(v.cmp); }
        if (!inQv) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null,'',u); } catch(e){} }
      }
      var dot, txt, cls = '';
      if (!v && hasOptions) { dot = 'ds-dot'; txt = DS.t('select_your_size', 'Select your size'); }
      else if (v && !v.available) { dot = 'ds-dot ds-dot--out'; txt = DS.t('sold_out_size', 'Sold out in this size'); }
      else if (v && v.qty > 0 && v.qty <= low) { dot = 'ds-dot ds-dot--low ds-dot--pulse'; txt = (root.dataset.tLow || 'Only [count] left').replace('[count]', v.qty); cls = 'is-low'; }
      else { dot = 'ds-dot ds-dot--pulse'; txt = (root.dataset.tInstock || 'In stock'); }
      stock.className = 'ds-pdp__stock ' + cls;
      stock.innerHTML = '<span class="' + dot + '"></span><span>' + txt + '</span>';
      var ok = v && v.available;
      addBtn.disabled = !!(v && !v.available);
      addBtn.textContent = !v ? DS.t('select_size', 'Select size') : (ok ? DS.t('add_to_cart', 'Add to cart') + ' · ' + DS.money(v.price) : DS.t('sold_out', 'Sold out'));
      addBtn.setAttribute('data-label', addBtn.textContent);
      if (buyBtn) buyBtn.hidden = !ok;
      if (barMeta) barMeta.textContent = (v ? DS.money(v.price) : '') + (sizeIdx > -1 && chosen[sizeIdx] ? ' · ' + chosen[sizeIdx] : '');
      if (barAdd) { barAdd.textContent = !v ? DS.t('select_size', 'Select size') : (ok ? DS.t('add_to_cart', 'Add to cart') : DS.t('sold_out', 'Sold out')); barAdd.disabled = !!(v && !v.available); }
      if (v && v.media) {
        var slide = root.querySelector('[data-media-id="' + v.media + '"]');
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft - slide.parentElement.offsetLeft, behavior: 'smooth' });
      }
    }
    opts.forEach(function(f, i){
      f.querySelectorAll('.ds-size').forEach(function(b){
        b.addEventListener('click', function(){ chosen[i] = b.dataset.value; render(); });
      });
    });
    function needSize(){
      var f = opts[sizeIdx > -1 ? sizeIdx : 0]; if (!f) return;
      var row = f.querySelector('.ds-pdp__values');
      row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake');
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function add(btn){
      var v = match();
      if (!v) return needSize();
      if (!v.available) return;
      DS.addToCart(v.id, 1, btn, { title: title, variant: v.options.join(' / '), image: image });
    }
    addBtn.addEventListener('click', function(){ add(addBtn); });
    if (barAdd) barAdd.addEventListener('click', function(){ add(barAdd); });
    if (buyBtn) buyBtn.addEventListener('click', function(){ var v = match(); if (!v) return needSize(); DS.buyNow(v.id); });
    var guideBtn = root.querySelector('[data-ds-open-guide]'), guide = root.querySelector('[data-ds-guide]');
    if (guideBtn && guide) guideBtn.addEventListener('click', function(){ guide.open = true; guide.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    var cutoff = parseInt(root.dataset.cutoff || '14', 10);
    function addBiz(d, n){ d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var now = new Date(), start = new Date(now);
    if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) start = addBiz(now, 1);
    var fmt = function(d){ try { return d.toLocaleDateString(document.documentElement.lang || 'es', { weekday: 'short', day: 'numeric', month: 'short' }); } catch(e){ return d.toDateString(); } };
    root.querySelectorAll('[data-ds-eta]').forEach(function(el){
      var r = el.getAttribute('data-ds-eta').split('-'), a = addBiz(start, +r[0]), b = addBiz(start, +r[1]);
      el.textContent = DS.t('arrives', 'arrives') + ' ' + (r[0] === r[1] ? fmt(a) : fmt(a) + ' - ' + fmt(b));
    });

    /* gallery: thumbs (desktop) + counter (mobile) + prev/next arrows */
    var track = root.querySelector('[data-ds-track]'), cur = root.querySelector('[data-ds-cur]');
    var gallery = root.querySelector('[data-ds-gallery]');
    if (track && gallery && track.children.length > 1) {
      var wrap = document.createElement('div'); wrap.className = 'ds-pdp__arrows'; gallery.appendChild(wrap);
      var mk = function(dir){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ds-pdp__arrow ds-pdp__arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? DS.t('prev', 'Previous') : DS.t('next', 'Next'));
        b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '"/></svg>';
        b.addEventListener('click', function(){ track.scrollBy({ left: (dir === 'prev' ? -1 : 1) * track.clientWidth, behavior: 'smooth' }); });
        wrap.appendChild(b); return b;
      };
      var prev = mk('prev'), next = mk('next');
      var slides = [].slice.call(track.children), thumbs = [];
      var tw = document.createElement('div'); tw.className = 'ds-pdp__thumbs';
      slides.forEach(function(sl, k){
        var im = sl.querySelector('img'); if (!im) return;
        var t = document.createElement('button'); t.type = 'button'; t.className = 'ds-pdp__thumb';
        t.setAttribute('aria-label', (k + 1) + ' / ' + slides.length);
        var ti = document.createElement('img'); ti.alt = ''; ti.loading = 'lazy';
        ti.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=200');
        t.appendChild(ti);
        t.addEventListener('click', function(){ track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        tw.appendChild(t); thumbs[k] = t;
      });
      if (thumbs.length > 1) { gallery.insertBefore(tw, track); gallery.classList.add('has-thumbs'); }
      var fit = function(){ tw.style.maxHeight = track.offsetHeight ? track.offsetHeight + 'px' : ''; };
      var upd = function(){
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (cur) cur.textContent = i + 1;
        thumbs.forEach(function(t, k){ if (t) t.classList.toggle('is-on', k === i); });
        var at = thumbs[i]; if (at && tw.offsetParent) { var top = at.offsetTop - tw.offsetTop; if (top < tw.scrollTop || top + at.offsetHeight > tw.scrollTop + tw.clientHeight) tw.scrollTop = top - 10; }
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', function(){ fit(); upd(); });
      window.addEventListener('load', fit); setTimeout(fit, 400);
      fit(); upd();
    }
    if (bar && !inQv && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ es.forEach(function(e){
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (barAdd) barAdd.tabIndex = past ? 0 : -1;
      }); }).observe(root.querySelector('[data-ds-actions]'));
    }
    render();
  }
  function all(scope){ (scope || document).querySelectorAll('[data-ds-pdp]').forEach(init); }
  window.DS_pdp_init = all;
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', function(){ all(); });
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();